module.exports = __webpack_public_path__ + "img/geofisica_4-3_682.0fee7826.jpg";